import api from "./api";

// Sugerencia por Geolocalizacion. api-central reenvia a EMSYS con los mismos
// parametros que usa el reporte web, asi que los filtros se llaman igual.
// Con Google Maps una consulta por PS de 50 operarios puede pasar los 30 s del
// timeout general; api-central espera hasta 60 s a EMSYS.
const TIMEOUT_MS = 60000;

const sugerenciaPs = {
  catalogo() {
    return api.get(`/sugerencia-ps/catalogo`);
  },
  porOperario(params: Record<string, string>) {
    const search = new URLSearchParams(params);
    return api.get(`/sugerencia-ps/por-operario?${search.toString()}`, { timeout: TIMEOUT_MS });
  },
  porPs(params: Record<string, string>) {
    const search = new URLSearchParams(params);
    return api.get(`/sugerencia-ps/por-ps?${search.toString()}`, { timeout: TIMEOUT_MS });
  },
};

export default sugerenciaPs;
